import React, { useCallback, useReducer, useEffect } from 'react';
import useSkipUpdate from '../../hooks/useSkipRender';
import TimeBasedSchedulerGeneratorView from '../view/TimeBasedSchedulerGeneratorView';

// const MOCK_OBJ = {
//   id: '0f3dc339-d3f5-47de-b3be-9f66db23b969',
//   jobType: 'automations',
//   assetId: 'ddcc0281-0922-4f8e-b7ea-b40abb7f3b04',
//   automationId: 'abc1234',
//   title: 'Last Updated Date',
//   isActive: true,
//   condition: {
//     conditionType: 'date',
//     statusList: [],
//     dateOperator: 'after',
//     interval: 30,
//     intervalUnit: 'day',
//     logicRules: '[]'
//   }
// };

const defualtState = {
  condition: {
    conditionType: 'date',
    interval: 30,
    intervalUnit: 'day',
    dateOperator: 'after'
  }
};

const TimeBasedReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    case 'update_condition':
      return {
        ...state,
        condition: { ...(state.condition || {}), ...payload }
      };
    default:
      return state;
  }
};

/**
 *
 * @param {Object} schedule - Object that holds data for the view to use (format = mock object at the top)
 * @param {Function} update - A function to get the updated dataBlock
 */
const TimeBasedSchedulerGeneratorEngine = ({
  schedule = defualtState,
  update = dBlock => dBlock
}) => {
  const [data, dispatch] = useReducer(TimeBasedReducer, schedule);
  //   const { shouldSkipUpdate, skipUpdate } = useSkipUpdate();

  useEffect(() => {
    // if (shouldSkipUpdate()) {
    //   return;
    // }
    update(data);
  }, [data]);

  const setInterval = useCallback(v => {
    let value = parseInt(v.target.value.replace(/[^\d.]+/g, ''));
    if (value < 0) {
      value = 0;
    }
    // if (value > 999) {
    //   value = 999;
    // }

    dispatch({ type: 'update_condition', payload: { interval: value } });
  }, []);

  const viewProps = {
    interval: data.condition.interval,
    intervalUnit: data.condition.intervalUnit,
    setInterval,
    dispatch
  };

  return <TimeBasedSchedulerGeneratorView {...viewProps} />;
};

export default TimeBasedSchedulerGeneratorEngine;
